import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
import { AuthProvider } from './contexts/AuthContext';
import AuthPage from './pages/Auth';
import RoleSelector from './pages/RoleSelector';
import OnboardingPage from './pages/Onboarding';
import PrivacyPolicyPage from './pages/PrivacyPolicy';
import TermsOfServicePage from './pages/TermsOfService';
import BookPage from './pages/BookPage';
import { Navigation } from './components/Navigation';
import { HeroSection } from './components/HeroSection';
import { HowItWorksPlayers } from './components/HowItWorksPlayers';
import { HowItWorksOwners } from './components/HowItWorksOwners';
import { FeatureHighlights } from './components/FeatureHighlights';
import { GivingBack } from './components/GivingBack';
import { CTAFooter } from './components/CTAFooter';

export default function App() {
  useEffect(() => {
    // Smooth scroll behavior for the entire page
    document.documentElement.style.scrollBehavior = 'smooth';

    // Intersection Observer for fade-in animations
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-fade-in');
          }
        });
      },
      { threshold: 0.1 }
    );

    // Observe all sections
    const sections = document.querySelectorAll('section');
    sections.forEach((section) => {
      section.classList.add('opacity-0', 'translate-y-8');
      observer.observe(section);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Auth routes */}
          <Route path="/login" element={<AuthPage />} />
          <Route path="/role-selector" element={<RoleSelector />} />
          <Route path="/onboarding" element={<OnboardingPage />} />

          {/* Booking deep link */}
          <Route path="/book/:courseId" element={<BookPage />} />

          {/* Legal routes */}
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-service" element={<TermsOfServicePage />} />

          {/* Main landing page route */}
          <Route
            path="/"
            element={
              <div className="min-h-screen bg-background">
                <Navigation />
                <main>
                  <HeroSection />
                  <HowItWorksPlayers />
                  <HowItWorksOwners />
                  <FeatureHighlights />
                  <GivingBack />
                  <CTAFooter />
                </main>

                <style>{`
                  @keyframes fade-in {
                    from {
                      opacity: 0;
                      transform: translateY(2rem);
                    }
                    to {
                      opacity: 1;
                      transform: translateY(0);
                    }
                  }

                  .animate-fade-in {
                    animation: fade-in 0.6s ease-out forwards;
                  }
                `}</style>
              </div>
            }
          />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
